import type { TreasuryViewProps } from "@/domains/treasury/types"
import { Card } from "@/components/card"
import { ExternalLinkIcon } from "@/domains/icons"

export const TreasuryView = ({ debankBundleUrl }: TreasuryViewProps) => {
  return (
    <div className="flex flex-col gap-6">
      <p className="max-w-3xl text-t200">
        The Scale treasury holds the assets backing the project across multiple wallets. View the full portfolio
        composition, chain-by-chain breakdown, and protocol positions on DeBank.
      </p>

      <div className="grid gap-4 lg:grid-cols-[1fr_0.8fr]">
        <a
          href={debankBundleUrl}
          target="_blank"
          rel="noreferrer noopener"
          className="block focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <Card.Container className="h-full cursor-pointer flex-row items-center gap-4 transition-colors hover:border-p300-light hover:bg-p400-light">
            <div className="flex flex-1 flex-col gap-2">
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-t300">External Verification</p>
              <h3 className="text-xl font-semibold text-t100">View treasury on DeBank</h3>
              <p className="text-sm leading-6 text-t200">
                Portfolio overview across all treasury addresses with token balances, protocol positions, and chain
                breakdown.
              </p>
            </div>
            <ExternalLinkIcon className="h-5 w-5 shrink-0 text-t200" />
          </Card.Container>
        </a>

        <Card.Container className="gap-4">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-t300">Trust Model</p>
            <h3 className="mt-2 text-xl font-semibold text-t100">Public by default</h3>
          </div>
          <div className="grid gap-3 sm:grid-cols-3 lg:grid-cols-1">
            <TreasuryTrustItem label="Wallets" value="Linked" />
            <TreasuryTrustItem label="Positions" value="On-chain" />
            <TreasuryTrustItem label="Review" value="External" />
          </div>
        </Card.Container>
      </div>
    </div>
  )
}

const TreasuryTrustItem = ({ label, value }: { label: string; value: string }) => {
  return (
    <div className="rounded-xl border border-p300-light bg-p300 p-3">
      <p className="text-[10px] font-bold uppercase tracking-[0.14em] text-t300">{label}</p>
      <p className="mt-1 text-base font-semibold text-t100">{value}</p>
    </div>
  )
}
